import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { useLinearLocale } from '../locale/LocaleContext.mjs';
import { Typography } from '../typography/Typography.mjs';
import { localeValues } from './constants/localeValues.mjs';

function SearchEmptyImpl() {
  const { locale } = useLinearLocale();
  return /* @__PURE__ */ jsx(StyledRoot, { children: /* @__PURE__ */ jsx(Typography, { color: "grayLight", children: localeValues[locale].emptyText }) });
}
const StyledRoot = styled("div", {
  fontSize: 14,
  borderRadius: 6,
  display: "flex",
  alignItems: "center",
  padding: "0 8px",
  margin: "0 6px",
  fontWeight: 600,
  height: 32
});

export { SearchEmptyImpl as default };
//# sourceMappingURL=SearchEmptyImpl.mjs.map
